<template>
    <div class="orders-date-picker">
        <button class="btn btn-default float-right ml-3"
                @click="filter"
                v-text="Lang.get('filter')"></button>
        <div class="float-right">
            <datepicker v-model="dateEnd"
                        name="dateEnd"
                        :language="sk"
                        :monday-first="true"
                        :full-month-name="true"
                        input-class="form-control datepicker ml-2"
                        :placeholder="Lang.get('messages.until') + ':'"
                        wrapper-class="float-right"
            ></datepicker>
            <datepicker v-model="dateStart"
                        name="dateStart"
                        :language="sk"
                        :monday-first="true"
                        :full-month-name="true"
                        input-class="form-control datepicker"
                        :placeholder="Lang.get('messages.from') + ':'"
                        wrapper-class="float-right"
            ></datepicker>
        </div>
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import {sk, cs} from 'vuejs-datepicker/dist/locale'

    export default {
        components: {
            Datepicker
        },

        props: ['dateStart', 'dateEnd'],

        data () {
            return {
                sk: sk,
                cs: cs,
            }
        },

        computed: {
            dateStartTimestamp() {
                return moment(this.dateStart).unix();
            },
            dateEndTimestamp() {
                return moment(this.dateEnd).unix();
            }
        },

        methods: {
            filter() {
                window.location.href = '/admin/orders/' +
                    '?dateStart=' + (+ this.dateStartTimestamp) +
                    '&dateEnd=' + (+ this.dateEndTimestamp);
            }
        }
    }
</script>

<style scoped>
    .orders-date-picker {
        margin-top: 1px;
    }
</style>
